// extracted by mini-css-extract-plugin
export default {"box":"Header_box__XjM5R","logo":"Header_logo__UsziS","list":"Header_list__Ucifz","button":"Header_button__eZN2O"};